import { useQuery } from '@apollo/react-hooks';

import { MentionsUserInfoQuery } from '../graphql/MentionsUserInfoQuery.graphql';

type MentionsUserInfoQueryProps = {
	mentionedUserId: string | null;
	currentUserId: string | null;
	isMentionsNotificationsEnabled: boolean;
};

type Photo = {
	value: string;
};

type UserInfoData = {
	user: {
		displayName: string;
		photos: Photo[];
	};
};

export const useMentionsUserInfoQuery = ({
	mentionedUserId,
	currentUserId,
	isMentionsNotificationsEnabled,
}: MentionsUserInfoQueryProps) => {
	const { data: userInfoData, error: userInfoError } = useQuery<UserInfoData>(
		MentionsUserInfoQuery,
		{
			variables: { accountId: mentionedUserId },
			skip:
				!isMentionsNotificationsEnabled || !mentionedUserId || currentUserId === mentionedUserId,
		},
	);

	return {
		userInfoData,
		userInfoError,
	};
};
